
export   const products = [
    { 
      id: 68, 
      name: 'LED Round Conceal Panel Black', 
      description: 'Consistent CCT Output<br>• No flickering, UV/IR & Mercury free<br>• Lumen Maintenance after 2000 Hours > 90%<br>• Good CRI Level<br>• Tested 2000 Hours<br>• Life Time 30,000 hrs.', 
      imageUrls: ['../Assets/LEDpanel/Panelblackanglernd.jpg', '../Assets/LEDpanel/Panelblackfrontrnd.jpg', '../Assets/LEDpanel/Panelnickelpacketrnd.jpg'],
      tableimgUrl: ['../Assets/Table/Paneltable.JPG'] 
    },
    { 
      id: 69, 
      name: 'LED Square Conceal Panel Black', 
      description: 'Consistent CCT Output<br>• No flickering, UV/IR & Mercury free<br>• Lumen Maintenance after 2000 Hours > 90%<br>• Good CRI Level<br>• Tested 2000 Hours<br>• Life Time 30,000 hrs.', 
      imageUrls: ['../Assets/LEDpanel/Panelblackfrontsqr.jpg', '../Assets/LEDpanel/Panelblackbacksqr.jpg', '../Assets/LEDpanel/Panelblackpacketsqr.jpg'],
      tableimgUrl: ['../Assets/Table/Paneltable.JPG'] 
    },
    { 
      id: 70, 
      name: 'LED Round Conceal Panel White', 
      description: 'Consistent CCT Output<br>• No flickering, UV/IR & Mercury free<br>• Lumen Maintenance after 2000 Hours > 90%<br>• Good CRI Level<br>• Tested 2000 Hours<br>• Life Time 30,000 hrs.', 
      imageUrls: ['../Assets/LEDpanel/Panelwhitefrontrnd.jpg', '../Assets/LEDpanel/Panelwhitebackrnd.jpg', '../Assets/LEDpanel/Panelwhitepacketrnd.jpg'],
      tableimgUrl: ['../Assets/Table/Paneltable.JPG'] 
    },
    { 
      id: 71, 
      name: 'LED Square Conceal Panel White', 
      description: 'Consistent CCT Output<br>• No flickering, UV/IR & Mercury free<br>• Lumen Maintenance after 2000 Hours > 90%<br>• Good CRI Level<br>• Tested 2000 Hours<br>• Life Time 30,000 hrs.', 
      imageUrls: ['../Assets/LEDpanel/Panelwhitefrontsqr.jpg', '../Assets/LEDpanel/Panelwhitebacksqr.jpg', '../Assets/LEDpanel/Panelwhitepacketsqr.jpg'],
      tableimgUrl: ['../Assets/Table/Paneltable.JPG'] 
    },
    { 
      id: 72, 
      name: 'LED Round Conceal Panel Nickel', 
      description: 'Consistent CCT Output<br>• No flickering, UV/IR & Mercury free<br>• Lumen Maintenance after 2000 Hours > 90%<br>• Good CRI Level<br>• Tested 2000 Hours<br>• Life Time 30,000 hrs.', 
      imageUrls: ['../Assets/LEDpanel/Panelnickelfrontrnd.jpg', '../Assets/LEDpanel/Panelnickelbackrnd.jpg', '../Assets/LEDpanel/Panelnickelpacketrnd.jpg'],
      tableimgUrl: ['../Assets/Table/Paneltable.JPG'] 
    },
    { 
      id: 73, 
      name: 'LED Square Conceal Panel Nickel', 
      description: 'Consistent CCT Output<br>• No flickering, UV/IR & Mercury free<br>• Lumen Maintenance after 2000 Hours > 90%<br>• Good CRI Level<br>• Tested 2000 Hours<br>• Life Time 30,000 hrs.', 
      imageUrls: ['../Assets/LEDpanel/Panelnickelfrontsqr.jpg', '../Assets/LEDpanel/Panelnickelbacksqr.jpg', '../Assets/LEDpanel/Panelnickelpacketsqr.jpg'],
      tableimgUrl: ['../Assets/Table/Paneltable.JPG'] 
    },
    { 
      id: 74, 
      name: 'LED Square Surface Panel White', 
      description: 'Consistent CCT Output<br>• No flickering, UV/IR & Mercury free<br>• Lumen Maintenance after 2000 Hours > 90%<br>• Good CRI Level<br>• Tested 2000 Hours<br>• Life Time 30,000 hrs.', 
      imageUrls: ['../Assets/LEDpanel/Surfacepanelfrontsqr.jpg', '../Assets/LEDpanel/Surfacepanelbacksqr.jpg', '../Assets/LEDpanel/Surfacepanelpacketsqr.jpg'],
      tableimgUrl: ['../Assets/Table/Paneltable.JPG']  
    },
    { 
      id: 75, 
      name: 'LED Round Multi Colour Surface Panel', 
      description: 'Consistent CCT Output<br>• No flickering, UV/IR & Mercury free<br>• Lumen Maintenance after 2000 Hours > 90%<br>• Good CRI Level<br>• Tested 2000 Hours<br>• Life Time 30,000 hrs.', 
      imageUrls: ['../Assets/LEDpanel/Multipanelfront.jpg', '../Assets/LEDpanel/Multipanelback.jpg', '../Assets/LEDpanel/Multipanelpacket.jpg'],
      tableimgUrl: ['../Assets/Table/Paneltable.JPG']  
    },
    
     
  
  
  ];
    
    export default {
        products,
    }
  